<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tencentadgroups}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentadgroups:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentadgroups:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="campaignId" label="推广计划 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adgroupId" label="广告组 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adgroupName" label="广告组名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="siteSet" label="投放版位集和" header-align="center" align="center"></el-table-column>
        
        <el-table-column prop="automaticSiteEnabled" label="是否开启自动版位功能" header-align="center" align="center"></el-table-column>
        <el-table-column prop="optimizationGoal" label="广告优化目标类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="billingEvent" label="计费类型" header-align="center" align="center"></el-table-column>
        <!-- CPC 出价限制：介于 10 分-10,000 分之间（0.1 元-100 元，单位为人民币）
CPM 出价限制：介于 150 分-99,900 分之间（1.5 元-999 元，单位为人民币，当 SITE_SET 仅为 SITE_SET_PCQQ 时，介于 50 分-99,900 分之间）
CPA 出价限制：介于 100 分-50,000 分之间（1 元-500 元，单位为人民币）
oCPC/oCPM 出价限制：介于 1 分-500,000 分之间（0.01 元-5000 元，单位为人民币） -->
        <el-table-column prop="bidAmount" label="广告出价，单位为分

" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalBudget" label="总预算，单位为分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dailyBudget" label="广告组日预算，单位为分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promotedObjectType" label="推广目标类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promotedObjectId" label="推广目标 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="appAndroidChannelPackageId" label="安卓应用渠道包" header-align="center" align="center"></el-table-column>
        <el-table-column prop="miniGameProgramId" label="微信小游戏 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingId" label="定向 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targeting" label="定向详细设置，存放所有定向条件" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingTranslation" label="已选择定向条件的描述" header-align="center" align="center"></el-table-column>
        <!-- true：包含 API 暂不支持读写的定向信息，false： -->
        <el-table-column prop="isIncludeUnsupportedTargeting" label="是否包含不支持定向" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sceneSpec" label="场景定向" header-align="center" align="center"></el-table-column>
        <el-table-column prop="flowOptimizationEnabled" label="	是否使用智能场景匹配" header-align="center" align="center"></el-table-column>
        <el-table-column prop="beginDate" label="开始投放日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="firstDayBeginTime" label="首日开始投放时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="endDate" label="	结束投放日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="timeSeries" label="投放时间段" header-align="center" align="center"></el-table-column>
        <el-table-column prop="configuredStatus" label="客户设置的状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="customizedCategory" label="自定义分类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="lastModifiedTime" label="最后修改时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adCount" label="广告数量，创意数量查询" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dynamicAdSpec" label="动态商品广告属性" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userActionSets" label="用户行为数据源" header-align="center" align="center"></el-table-column>
        <el-table-column prop="additionalUserActionSets" label="补充的 app 用户行为数据源" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isDeleted" label="是否已删除" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dynamicCreativeId" label="DC 动态创意 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isRewardedVideoAd" label="是否是激励视频广告" header-align="center" align="center"></el-table-column>
        <el-table-column prop="costGuaranteeMessage" label="成本保障状态信息说明" header-align="center" align="center"></el-table-column>
        <el-table-column prop="costGuaranteeStatus" label="成本保障状态，成本保障状态定义" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bidStrategy" label="	出价策略，仅 oCPC/oCPM 广告可设置，枚举列表" header-align="center" align="center"></el-table-column>
        <el-table-column prop="coldStartAudience" label="	扩量种子人群" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoAudience" label="是否使用系统优选" header-align="center" align="center"></el-table-column>
        <el-table-column prop="expandEnabled" label="是否使用自动扩量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="expandTargeting" label="	扩量不可突破定向" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepConversionSpec" label="oCPC/oCPM" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepOptimizationActionType" label="oCPC/oCPM 深度优化方式配置" header-align="center" align="center"></el-table-column>
        <el-table-column prop="poiList" label="门店 id 列表" header-align="center" align="center"></el-table-column>
        <el-table-column prop="conversionId" label="转化 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepConversionBehaviorBid" label="深度优化行为的出价，单位为分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepConversionWorthRate" label="	深度优化价值的期望" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepConversionWorthAdvancedRate" label="	强化优化价值的期望" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deepConversionBehaviorAdvancedBid" label="加强优化行为的出价" header-align="center" align="center"></el-table-column>
        <el-table-column prop="androidChannelPackageAuditMessage" label="广告包渠道包审核消息" header-align="center" align="center"></el-table-column>
        <el-table-column prop="systemStatus" label="广告组在系统中的状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bidMode" label="出价方式" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="广告状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bidAdjustment" label="出价系数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoAcquisitionEnabled" label="是否开启一键起量" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoAcquisitionBudget" label="一键起量探索预算，单位为分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creativeDisplayType" label="创意展示类型，不填该字段默认优选模式，" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoDerivedCreativeEnabled" label="是否开启自动衍生视频创意" header-align="center" align="center"></el-table-column>
        <el-table-column prop="smartBidType" label="出价类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="smartCostCap" label="自动出价下，单位为分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="marketingScene" label="营销目标" header-align="center" align="center"></el-table-column>
        <el-table-column prop="customAdgroupTag" label="广告标签" header-align="center" align="center"></el-table-column>
        <el-table-column prop="smartTargeting" label="智能定向功能" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dynamicCreativeIdSet" label="DC 动态创意 id 集合" header-align="center" align="center"></el-table-column>
        <el-table-column prop="systemStatusExplanation" label="广告系统状态详情内容" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoDerivedLandingPageSwitch" label="是否开启自动衍生落地页开关" header-align="center" align="center"></el-table-column>
        <el-table-column prop="searchExpandTargetingSwitch" label="搜索定向拓展开关" header-align="center" align="center"></el-table-column>
        <el-table-column prop="autoAcquisitionStatus" label="一键起量状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bidScene" label="出价场景" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="$hasPermission('sys:tencentadgroups:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button> -->
            <el-button v-if="$hasPermission('sys:tencentadgroups:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tencentadgroups-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tencentadgroups/page',
        getDataListIsPage: true,
        exportURL: '/sys/tencentadgroups/export',
        deleteURL: '/sys/tencentadgroups',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
